import React, { Component } from 'react';
import { connect } from "react-redux";
import { Field } from "redux-form";

import Input from "../Input";
import Button from "../Button";
import SelectBox from "../SelectBox";

import * as countryCodeActions from '../../../actions/countryCodes';
import * as smsAuthActions from '../../../actions/smsAuth';

import styles from './styles.scss'

class SmsAuthSetup extends Component {
    constructor() {
        super();

        this.state = {
            countryId: null,
            selectedCountryCode: '',
            selectedCountryDialCode: '',
            auth_phone: ''
        }

        this._preventSubmit = this._preventSubmit.bind(this);
    }

    componentDidMount() {
        if(this.props.telephoneAuth){
            this.setState({
                auth_phone: this.props.telephoneAuth.telephone
            });
        }

        return this.props.getCountryCodes()
            .then(() => this._setCountry());
    }

    _setCountryState(setCountry){
        return this.setState({
            countryId: setCountry.id,
            selectedCountryCode: setCountry.iso_alpha_2_code,
            selectedCountryDialCode: setCountry.dial_code
        });
    }

    _setCountry(){
        if(this.props.telephoneAuth){
            const setCountry = this.props.countryCodes.countryCodes.find(country => country.id === this.props.telephoneAuth.country_id);
            this._setCountryState(setCountry);
        }else{
            this.props.setCountryByIp()
                .then(() => {
                    const setCountry = this.props.countryCodes.countryCodes.find(country => country.iso_alpha_2_code === this.props.countryCodes.setCountry);
                    this._setCountryState(setCountry);
                });
        }
    }

    _copyPhoneNumber(e){
        e.preventDefault();
        this.setState({
            auth_phone: this.props.telephone
        });
    }

    _changeCountryCode(e){
        const countryCode = e.target.value
        const country = this.props.countryCodes.countryCodes.find(country => country.iso_alpha_2_code === countryCode);
        this.setState({
            countryId: country.id,
            selectedCountryCode: countryCode,
            selectedCountryDialCode: country.dial_code
        });
    }

    _createAuthParams(extraParams = {}){
        return {
            ...extraParams,
            countryId: this.state.countryId,
            dial_code: this.state.selectedCountryDialCode,
            phone_number: this.state.auth_phone
        }
    }

    _handleVerifySmsCode(){
        let params = this._createAuthParams({
            sms_code: document.getElementById('sms_auth_code').value,
            isUpdate: false
        });

        if(this.props.telephoneAuth){
            params = {
                ...params,
                isUpdate: true
            }
        }

        return this.props.verifySmsCode(params)
            .then(() => {
                if (this.props.smsAuth.smsAuthStatus === "approved") {
                    this.props.hideVerifyInput();
                    this.props.completeSetup();
                }
            });
    }

    _handleAuthPhoneInput(e){
        this.setState({
            auth_phone: e.target.value
        });
    }

    _handleVerifyInput(e){
        e.preventDefault();
        this.props.hideVerifyInput();
    }

    _preventSubmit(e){
        if(e.keyCode === 13){
            e.preventDefault();
            this._handleVerifySmsCode();
        }
    }

    render(){

        return (
            <div className={styles['sms-auth-setup__container']}>
                <p>
                    Please enter your phone number and then click "Send Code". You will be sent an SMS containing a code which you will need to enter.
                </p>
                {!this.props.smsAuth.showVerifySmsInput ? (
                    <div>
                        <div className={styles.inputSplit}>
                            <div className={styles['flag-container']}>
                                <img src={`http://www.countryflags.io/${this.state.selectedCountryCode}/flat/64.png`} alt="" />
                            </div>
                            <div className={styles['dropdown-code-container']}>
                                <SelectBox
                                    containerClassName={styles['country-dropdown']}
                                    label="Country"
                                    onChange={this._changeCountryCode.bind(this)}
                                    input={{ name: 'country_select', value: this.state.selectedCountryCode }}
                                    required={true}
                                >
                                    {this.props.countryCodes.countryCodes.length > 0 && this.props.countryCodes.countryCodes.map((country, index) => {
                                        if(country.name !== ""){
                                            return (
                                                <option
                                                    key={index}
                                                    value={country.iso_alpha_2_code}
                                                >
                                                    {country.name}
                                                </option>
                                            )
                                        }
                                        return null;
                                    })}
                                </SelectBox>
                                <span className={styles['country-code']}>+{this.state.selectedCountryDialCode}</span>
                            </div>
                            <div className={styles['phone-number']}>
                                <Field
                                    component={Input}
                                    type="text"
                                    id="auth_phone"
                                    label="Mobile Number"
                                    required={true}
                                    input={{name: "auth_phone", value:this.state.auth_phone, onChange: this._handleAuthPhoneInput.bind(this)}}
                                    meta={{error: this.props.smsAuth.errors.phone_number, touched: ('phone_number' in this.props.smsAuth.errors)}}
                                />
                                {(this.props.telephone && !this.props.telephoneAuth) && <a href="#" onClick={this._copyPhoneNumber.bind(this)}>Copy account telephone number</a>}
                            </div>
                        </div>
                        <div className={styles['auth_button']}>
                            <Button
                                className={styles['auth_button']}
                                type="button"
                                onClick={() => this.props.sendVerifyCode(this._createAuthParams())}
                            >Send Code</Button>
                            <Button
                                className={styles['auth_button']}
                                type="button"
                                theme="cancel"
                                onClick={this.props.toggleShowSmsSetup}
                            >Cancel SMS Setup</Button>
                        </div>
                    </div>
                ) : (
                    <div>
                        <div className={styles['auth_code_input']}>
                            <Field
                                component={Input}
                                type="text"
                                name="sms_auth_code"
                                id="sms_auth_code"
                                label="SMS Code"
                                onKeyDown={e => this._preventSubmit(e)}
                                meta={{error: this.props.smsAuth.errors.sms_code, touched: ('sms_code' in this.props.smsAuth.errors)}}
                            />
                        </div>
                        <p>
                            <a href="#" onClick={e => this._handleVerifyInput(e)}>Didnt receive a code? Click here to check your phone number and try again.</a>
                        </p>
                        <Button
                            className={styles['auth_button']}
                            type="button"
                            onClick={this._handleVerifySmsCode.bind(this)}
                        >Verify</Button>
                        <Button
                            className={styles['auth_button']}
                            type="button"
                            theme="cancel"
                            onClick={this.props.toggleShowSmsSetup}
                        >Cancel SMS Setup</Button>
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        countryCodes: state.countryCodes,
        smsAuth: state.smsAuth
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getCountryCodes(){
            return dispatch(countryCodeActions.getAll());
        },
        setCountryByIp(){
            return dispatch(countryCodeActions.getCountryByIp());
        },
        sendVerifyCode(params){
            return dispatch(smsAuthActions.sendToken(params));
        },
        verifySmsCode(params){
            return dispatch(smsAuthActions.verifySmsCode(params));
        },
        hideVerifyInput(){
            return dispatch(smsAuthActions.hideVerifyCodeInput())
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SmsAuthSetup);

